

  <form class="form-signin text-center">
    <div>
      <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200">
    </div>
    Verify
    <h1 class="h3 mb-3 font-weight-normal">{{ 'Login.Verify' | translate }}</h1>
    <h1 class="h3 mb-3 font-weight-normal">{{ 'Login.SecurityCode' | translate }}</h1>


    <label for="inputPassword" class="sr-only">{{ 'Login.InputPassword' | translate }}</label>

    <input type="text" class="form-control" placeholder="security code" [(ngModel)]="securityCode" [ngModelOptions]="{standalone: true}" required>
    <button class="btn btn-lg btn-primary btn-block btn_submit " type="submit" (click)="SubmitSecurityCode()">{{ 'Login.Submit' | translate }}</button>

    <p class="text-muted">&copy; {{ 'Login.Footer' | translate }}</p>
  </form>











